// extracted by mini-css-extract-plugin
export var completionBody = "_l1-2";
export var completionCard = "_l1-0";
export var completionFooter = "_l1-3";
export var completionTitle = "_l1-1";